import { fontSize } from '../../../foundation/fontSize'

export const GRID_FONT_SIZE = fontSize.X15
export const GRID_ROW_HEIGHT = 56
export const GRID_HEADER_ROW_HEIGHT = 65
export const GRID_COMPACT_ROW_HEIGHT = 32
export const GRID_COMPACT_HEADER_ROW_HEIGHT = 40
